if (!customElements.get('collection-description-toggle')) {
  customElements.define(
    'collection-description-toggle',
    class CollectionDescriptionToggle extends HTMLElement {
      constructor() {
        super();

        this.truncated = this.querySelector('.collection-hero__description-truncated');
        this.full = this.querySelector('.collection-hero__description-full');
        if (!this.truncated || !this.full) return;

        this.buttons = this.querySelectorAll('.collection-hero__description-toggle-btn');
        this.onToggle = this.onToggle.bind(this);
        this.buttons.forEach((button) => button.addEventListener('click', this.onToggle));
      }

      onToggle() {
        const expanded = !this.full.hidden;
        this.full.hidden = expanded;
        this.truncated.hidden = !expanded;
        this.buttons.forEach((button) => button.setAttribute('aria-expanded', String(!expanded)));
      }
    }
  );
}
